import request from '@utils/request';
import { ModuleStatusSchema, PropertySchema } from './schemas';
import { Response } from '@features/state';

export async function getProperty(id: number) {
  const { data } = await request.base.get(`properties/${id}`);
  return PropertySchema.passthrough().parse(data);
}

export async function getModuleStatuses({ siteSlug }: { siteSlug: string }) {
  const { data } = await request.v2.get(`/store/pages/site/${siteSlug}/modules`);
  return Response(ModuleStatusSchema).parse(data);
}
